import { createApp } from "vue";
import App from "./App.vue";
import Router from "./router";
import "bootstrap/scss/bootstrap-grid.scss";
import "bootstrap/scss/bootstrap-utilities.scss";
import "@splidejs/splide/dist/css/splide.min.css";
import "./assets/scss/main.scss";
import Store from "./store";
import { createHead, VueHeadMixin } from "@unhead/vue";
import VueGtag from "vue-gtag-next";
import posthog from "posthog-js";
const head = createHead();

posthog.init(process.env.VUE_APP_POSTHOG_PROJECT_TOKEN || "", {
  api_host: process.env.VUE_APP_POSTHOG_HOST || "https://us.i.posthog.com",
  defaults: "2026-01-30",
});

const app = createApp(App);

app.config.errorHandler = (err) => {
  posthog.captureException(err);
};

app
  .use(Router)
  .use(VueGtag, {
    property: {
      id: "G-T9FKKTY334",
    }
  }, Router)
  .mixin(VueHeadMixin)
  .use(head)
  .use(Store)
  .mount("#app");
